import script from "./pCheckbox.vue?vue&type=script&setup=true&lang=ts"
export * from "./pCheckbox.vue?vue&type=script&setup=true&lang=ts"

import "./pCheckbox.vue?vue&type=style&index=0&id=dfaf6aa8&lang=css"

const __exports__ = script;

export default __exports__